import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useFormUploadOtherDocs from "../lib/useFormUploadOtherDocs";
import { ReactComponent as UploadIcon } from "../../Asset/upload-cloud-02.svg";
import { ReactComponent as AddIcon } from "../../Asset/add-circle.svg";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";
import { CiFileOn } from "react-icons/ci";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import Spinner from "../../Utils/spinner/loading";
import "./otherdocs.css";

const UpdateOtherDocs = () => {
  const navigate = useNavigate();
  const { handleSubmit, loading, error, success } = useFormUploadOtherDocs();
  const [formData, setFormData] = useState([]);

  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    const newFormData = [...formData];
    newFormData[index] = {
      name: newFormData[index] ? newFormData[index].name : "",
      file: file,
    };
    setFormData(newFormData);
  };

  const handleNameChange = (e, index) => {
    const newName = e.target.value;
    const newFormData = [...formData];
    newFormData[index] = {
      name: newName,
      file: newFormData[index] ? newFormData[index].file : null,
    };
    setFormData(newFormData);
  };

  const addDocumentField = () => {
    setFormData([...formData, { name: "", file: null }]);
  };

  const removeDocument = (index) => {
    const newFormData = [...formData];
    newFormData.splice(index, 1);
    setFormData(newFormData);
  };

  const handleFinish = (e) => {
    e.preventDefault();
    handleSubmit(e, formData);
  };

  const formatFileSize = (size) => {
    if (size >= 1000000) {
      return (size / 1000000).toFixed(2) + " MB";
    } else if (size >= 1000) {
      return (size / 1000).toFixed(2) + " KB";
    } else {
      return size + " bytes";
    }
  };

  const capitalizeInitial = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  return (
    <div className="update-other-docs">
      <div className="wrap">

     
      <div className="header">
        <button onClick={() => navigate("/typeofupdate")}>Back</button>
        {/* <Link to="/">Charterer</Link> */}
        <BlackVatugIcon onClick={() => navigate("/")}/> 
        <button className="finished" onClick={handleFinish} disabled={loading}>
          {loading ? <Spinner /> : "Finish"}
        </button>
      </div>
      <form>
        <h2>Other Documents</h2>

        {formData.map((item, index) => (
          <div key={index} className="card">
            <input
              type="text"
              placeholder="Input name of document"
              value={item.name}
              onChange={(e) => handleNameChange(e, index)}
            />
            {!item.file && (
              <label>
                Document
                <span>
                  <input
                    type="file"
                    hidden
                    onChange={(e) => handleFileChange(e, index)}
                  />
                  {!item.file && (
                    <>
                      <UploadIcon />
                      <p>
                        Drop pdf here, <span>or browse</span>
                      </p>
                      <h5>Supports: PDF</h5>
                    </>
                  )}
                </span>
              </label>
            )}
            {item.file && (
              <div className="uploaded">
                <div className="wrap">
                  <CiFileOn className="file" />

                  <div className="in">
                    <span>
                      <h3>{capitalizeInitial(item.name)}</h3>
                      <p>{item.file.name}</p>
                    </span>
                    <p>{formatFileSize(item.file.size)} - 100% Uploaded</p>
                  </div>
                </div>
                <div className="last">
                  <IoCheckmarkDoneCircleOutline className="mark" />
                  <RiDeleteBin5Line
                    onClick={() => removeDocument(index)}
                    className="delete"
                  />
                </div>
              </div>
            )}
          </div>
        ))}

        {formData.length <= 0 ? (
          <button type="button" onClick={addDocumentField}>
            <AddIcon />
            Add Document
          </button>
        ) : (
          <button type="button" onClick={addDocumentField}>
            <AddIcon />
            Add More Document
          </button>
        )}

        {formData.length > 0 && (
          <button
            className="finished"
            onClick={handleFinish}
            disabled={loading}
          >
            {loading ? <Spinner /> : "Finish"}
          </button>
        )}
        {error && (
          <p style={{ margin: "auto", color: "red", fontFamily: "Montserrat" }}>
            {error}
          </p>
        )}
        {success && (
          <p
            style={{ margin: "auto", color: "green", fontFamily: "Montserrat" }}
          >
            {success}
          </p>
        )}
      </form>
      </div>
    </div>
  );
};

export default UpdateOtherDocs;
